<template>
  <div :class="cardClasses">
    <div v-if="$slots.header || title" class="border-b border-surface-200/60 dark:border-surface-800/60 px-6 py-5">
      <slot name="header">
        <h3 class="text-lg font-semibold text-surface-900 dark:text-surface-100">{{ title }}</h3>
      </slot>
    </div>

    <div :class="bodyClass">
      <slot />
    </div>

    <div v-if="$slots.footer" class="border-t border-surface-200/60 dark:border-surface-800/60 px-6 py-4 bg-surface-50/50 dark:bg-surface-900/50 rounded-b-2xl">
      <slot name="footer" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  padding: {
    type: String,
    default: 'normal',
    validator: (value) => ['none', 'sm', 'normal', 'lg'].includes(value)
  },
  hoverable: {
    type: Boolean,
    default: false
  },
  elevated: {
    type: Boolean,
    default: false
  }
})

const cardClasses = computed(() => {
  const base = props.elevated ? 'card-elevated' : 'card'
  const hover = props.hoverable ? 'cursor-pointer hover:scale-[1.01] hover:shadow-card-hover transition-all duration-300' : ''
  return [base, hover].filter(Boolean).join(' ')
})

const bodyClass = computed(() => {
  const paddings = {
    none: '',
    sm: 'p-4',
    normal: 'p-6',
    lg: 'p-8'
  }
  return paddings[props.padding]
})
</script>
